import PocketBase from 'pocketbase';
import {AsyncStorageAuthStore} from "@/auth/AsyncStorageAuthStore";
import {appConfig} from "@/app-config";

const PB_URL = appConfig.pocketbaseUrl;

const store = new AsyncStorageAuthStore();

export const pb = new PocketBase(PB_URL, store);

pb.autoCancellation(false);
